import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/

.breadcrumb {
  margin-bottom: 0.5rem;
  line-height: 1.1;
  display: flex;
  flex-wrap: wrap;
}

.breadcrumb ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Animations on slotted content doesnt appear to work in Chrome */
/* @media (prefers-reduced-motion: no-preference) {
  @keyframes slide-in {
    0% {
      opacity: 0;
      transform: translate3d(-6px, 0, 0);
    }
    100% {
      opacity: 1;
      transform: translate3d(0, 0px, 0);
    }
  }

  slot::slotted(*) {
    opacity: 0;
    animation: slide-in 300ms 1 linear forwards;
  }
  slot::slotted(*:nth-child(1)) { animation-delay: 0ms; }
  slot::slotted(*:nth-child(2)) { animation-delay: 100ms; }
  slot::slotted(*:nth-child(3)) { animation-delay: 200ms; }
  slot::slotted(*:nth-child(4)) { animation-delay: 300ms; }
  slot::slotted(*:nth-child(5)) { animation-delay: 400ms; }
  slot::slotted(*:nth-child(6)) { animation-delay: 500ms; }
} */


`;
